import { RQ, isIOS } from 'utils';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getAddressList: async function () {
    let self = this;
    const res = await RQ.mall.get('/api/app/OrderDeliveryAddress/listOrderDeliveryAddress');
    if (res && res.code == 0) {
      self.addressList.items = res.data;
    } else {
      this.tips(res.msg, 1500);
    }
  },
  confirmOrder: async function (goodsInfoId, goodsNum) {
    const res = await RQ.mall.post(
      '/api/app/order/confirmOrder',
      {
        goodsInfoId: 514,
        goodsNum: 1,
        specialId: undefined
      },
      { jsonBody: true }
    );

    if (res && res.code == 0) {
      this.settlement = res.data;
    } else {
      this.tips('购买失败');
    }
  },
  getOrderPrice: async function () {
    const { deliveryAddress, ...other } = this.postData;
    const params = {
      ...other,
      goodsNum: this.params.goodsNum,
      goodsInfoId: this.params.goodsInfoId
    };
    const res = await RQ.mall.post('/api/app/order/getOrderPrice', params, { jsonBody: true });
    if (res && res.code == 0) {
      this.settlement = {
        ...this.settlement,
        ...res.data
      };
    }
  },
  showAddressProup: function () {
    this.showAddress = true;
  },
  hideAddressProup: function () {
    this.showAddress = false;
    this.closeEditAddress();
  },
  closeEditAddress: function () {
    this.showEditAddress = false;
    this.addressForm = {};
  },
  showCouponsPopup: async function () {
    const res = await RQ.mall.get('/api/app/coupon/listAvailableCoupon', {
      goodsInfoId: this.params.goodsInfoId,
      goodsInfoCount: 1
    }, { jsonBody: true });
    if (res && res.code == 0) {
      this.showCoupons = true;
      this.coupons = res.data.availableList;
    } else {
      this.tips(res.msg);
    }
  },
  changedCoupon(v) {
    this.selectedCoupon = v.useId;
    console.log('this.selectedCoupon', this.selectedCoupon);
  },
  hideCouponPopup() {
    this.showCoupons = false;
  },
  unUseCoupon() {
    this.postData.useId = undefined;
    this.selectedCoupon = {};
    this.hideCouponPopup();
    this.getOrderPrice();
  },
  useCoupon() {
    console.log('this.selectedCoupon', this.selectedCoupon);
    this.postData.useId = this.selectedCoupon;
    this.hideCouponPopup();
    this.getOrderPrice();
  },
  selectAddress(address) {
    if (this.selectedAddress.deliveryAddressId == address.deliveryAddressId) {
      this.selectedAddress = {};
    } else {
      this.selectedAddress = address;
    }
  },
  confirmSelectAddress() {
    this.hideAddressProup();
    this.postData.deliveryAddressId = this.selectedAddress.deliveryAddressId;
    const address = this.selectedAddress;
    this.postData.deliveryAddress = {
      ...this.selectedAddress,
      fullAddress: `${address.province || ''}${address.city || ''}${address.area || ''}${address.deliveryAddress}`
    };
    this.getOrderPrice();
    console.log('this.postData', this.postData);
  },
  editAddress: async function (item) {
    this.addressForm = {
      ...item,
      addressValue: [`${item.provinceId}`, `${item.cityId}`, `${item.areaId}`]
      // addressValueStr :`${item.province||''}${item.city||''}${item.area||''}`
    };
    this.showEditAddress = true;
  },
  changeArea(value) {
    this.addressForm.addressValue = value;
  },
  saveAddress: async function () {
    var self = this;

    if (!/(^0\d{2,3}-?\d{7,8}$)|(^1\d{10}$)/.test(self.addressForm.deliveryPhone)) {
      self.tips('请输入正确收货人号码', 1500);
      return;
    }
    const postData = {
      deliveryAddressId: self.addressForm.deliveryAddressId,
      deliveryPerson: self.addressForm.deliveryPerson, //收货人
      deliveryPhone: self.addressForm.deliveryPhone, //收货电话
      provinceId: self.addressForm.addressValue[0], //省
      cityId: self.addressForm.addressValue[1], //市
      areaId: self.addressForm.addressValue[2], //区
      deliveryAddress: self.addressForm.deliveryAddress, //详细地址
      postCode: self.addressForm.postCode
    };
    if (self.addressForm.deliveryAddressId != undefined) {
      const d = await RQ.mall.put('/api/h5/OrderDeliveryAddress/updateOrderDeliveryAddress', postData, { jsonBody: true });
      if (d && d.code == 0) {
        this.closeEditAddress();
        self.getAddressList();
      } else {
        self.tips(d.msg);
      }
    } else {
      const d = await RQ.mall.post('/api/h5/OrderDeliveryAddress/saveOrderDeliveryAddress', postData, { jsonBody: true });
      if (d && d.code == 0) {
        this.closeEditAddress();
        self.getAddressList();
      } else {
        self.tips(d.msg);
      }
    }
  },
  addAddress() {
    this.showEditAddress = true;
    this.addressForm = {
      addressValue: []
    };
  },
  useCoin(checked) {
    this.postData.usedCoinState = checked ? 1 : 0;
    this.getOrderPrice();
  },
  preSubmitOrder: async function () {
    const postData = this.postData;
    const { deliveryWay, deliveryAddressId } = this.postData;
    if (deliveryWay == undefined) {
      return this.tips('请先选择配送方式');
    }
    if (deliveryAddressId == undefined) {
      return this.tips('请先选择收货地址');
    }
    if (this.settlement.tipMsg) {
      this.showFullExtension = true;
    } else {
      this.submitOrder();
    }
  },
  submitOrder: async function () {
    addClickAnalytics({ LogTitle: '提交订单' });
    const postData = this.postData;
    const params = {
      cartId: postData.cartId,
      goodsInfoId: postData.goodsInfoId,
      goodsNum: postData.goodsNum,
      productId: 1,
      deliveryWay: postData.deliveryWay,
      deliveryAddressId: postData.deliveryAddressId,
      storeId: undefined,
      usedCoinState: postData.usedCoinState,
      useId: postData.useId,
      leaveMessage: postData.leaveMessage,
      specialId: postData.specialId,
      isPlatform: G.is_platform !== undefined ? G.is_platform : 0,
      clientType: 2
    };
    const res = await RQ.mall.post('/api/app/order/saveOrder', params, { jsonBody: true });
    if (res.code == 0) {
      const { orderId, orderCode, orderPrice } = res.data;
      if (orderPrice === 0) {
        this.$router.replace({
          path: `/${G.enterprise}/cart/paySuccess?orderId=${orderId}&orderCode=${orderCode}&orderPrice=${orderPrice}`
        });
      } else {
        this.$router.replace(`/cartpay?orderId=${orderId}&enterprise=${G.enterprise}`);
      }
    } else {
      this.tips(res.msg);
    }
  },
  confirmFullDialog: function () {
    this.showFullExtension = false;
  }
};



// WEBPACK FOOTER //
// ./src/module/cart/settlement/action.js